/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from 'reactstrap';
import { ROLES } from 'routes';
import ReactTooltip from 'react-tooltip';
import { uiStateConstants } from '_reducers';
import { globalActions, siteActions } from '../../_actions';
import { history } from '../../_helpers';
import { useFilterNavByRoutePermissionsHook } from './Hooks/SidebarHooks';

const styles = {
  scrollableDiv: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
  },
};

const DefaultMainMenu = (props) => {
  const {
    accountID,
    auth: {
      me: { name, role },
    },
  } = props;

  const navItems = useFilterNavByRoutePermissionsHook(role);
  const isSupport = role === ROLES.SUPPORT;

  return (
    <aside className='main-sidebar'>
      {navItems.map((item) => {
        let { url } = item;
        if (item.noShow) {
          return null;
        }
        if (item?.children?.length) {
          url = `${item.url}${item.children[0].url.replace(
            ':accountID',
            accountID
          )}`;
        } else {
          ({ url } = item);
        }
        return (
          <Link to={url} key={item.name} className={item.linkClassName}>
            <i className={item.className} data-tip={item.name} />
            <ReactTooltip />
          </Link>
        );
      })}

      <UncontrolledDropdown className='last-group' direction='right'>
        <DropdownToggle tag='a'>
          <i className='icon-Global-System' data-tip='System/Settings' />
          <ReactTooltip />
        </DropdownToggle>
        <DropdownMenu className={!isSupport ? 'less-items' : ''}>
          <DropdownItem header>{name}</DropdownItem>
          {isSupport ? (
            <>
              <DropdownItem tag={Link} to='/system/sites'>
                System
              </DropdownItem>
              <DropdownItem tag={Link} to='/settings/users'>
                Settings
              </DropdownItem>
              <DropdownItem divider />
            </>
          ) : null}

          <DropdownItem tag={Link} to='/logout'>
            Logout
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    </aside>
  );
};

function DefaultSubmenu(props) {
  const {
    accountID,
    accounts,
    accountName,
    entity,
    getMachines,
    machines,
    setAccount,
    invalidateSites,
    auth: {
      me: { role },
    },
    location: { pathname },
  } = props;
  const dispatch = useDispatch();
  const navItems = useFilterNavByRoutePermissionsHook(role);

  useEffect(() => {
    if (accountID) {
      if (entity === 'configs') {
        getMachines(accountID);
      }
    }
  }, [ accountID, entity, getMachines ]);

  const showMenu = (currentMenu) => (currentMenu.children
      && currentMenu.children[0].url.indexOf(':accountID') !== -1)
    || currentMenu.entity;

  const handleInputChange = async (accountID) => {
    // On global account context change. invalidate the sites
    invalidateSites();
    dispatch({ type: uiStateConstants.RESET_UI_STATE });
    setAccount(accountID);

    const currentMenu = navItems.find(
      (item) => item.name.toLowerCase() === entity
    );
    let { url } = currentMenu;

    if (currentMenu.children) {
      url += currentMenu.children[0].url;
    }

    if (url) {
      history.push(url.replace(':accountID', accountID));
    }
  };

  let accountsResult = <div />;
  const accountNamePlaceHolder = accountName && accountName.length > 10
    ? `${accountName.substring(0, 10)}...`
    : accountName || 'Account';

  const currentMenu = navItems.find(
    (item) => item.name.toLowerCase() === entity
  );

  if (accounts) {
    accountsResult = accounts.map((account) => (
      <DropdownItem
        key={account.id}
        onClick={() => handleInputChange(account.id)}
        active={Number(accountID) === Number(account.id)}
      >
        {account.name}
      </DropdownItem>
    ));
  }

  // Neither the Landing page nor the Dashboard has secondary sidebar
  if (pathname === '/' || pathname === '/dashboard') {
    return null;
  }

  return (
    <aside className='secondary-sidebar'>
      <div className='sub-sidebar-logo'>
        <img src='img/CR_Epiroc_White_150.png' alt='CR Digital' />
      </div>

      {showMenu(currentMenu) && ( // Checks if the Account dropdown has to be shown
        <UncontrolledDropdown>
          <DropdownToggle color='light' caret>
            {accountNamePlaceHolder}
          </DropdownToggle>
          <DropdownMenu>{accountsResult && accountsResult}</DropdownMenu>
        </UncontrolledDropdown>
      )}

      {currentMenu.children // Displays the submenu
        && currentMenu.children.map((item) => {
          const url = currentMenu.url + item.url.replace(':accountID', accountID);
          let activeClass = pathname === url ? 'active' : '';

          if (!item.exact) {
            activeClass = pathname.toLowerCase().indexOf(url.toLowerCase()) === 0 ? 'active' : '';
          }
          return (
            <Link to={url} className={activeClass} key={item.name}>
              {item.name}
            </Link>
          );
        })}

      {entity === 'configs' // It shows the machines for the menu
        && machines && (
          <div style={styles.scrollableDiv}>
            {machines.map((item) => {
              const url = `${currentMenu.url}/${accountID}/${item.id}`;
              const activeClass = pathname === url ? 'active' : '';

              return (
                <Link to={url} className={activeClass} key={item.id}>
                  {item.name}
                </Link>
              );
            })}
          </div>
      )}
    </aside>
  );
}

const DefaultSidebar = (props) => {
  const {
    route: { entity },
  } = props;

  return (
    <div className='sidebar'>
      <DefaultMainMenu {...props} />
      <DefaultSubmenu {...props} entity={entity} />
    </div>
  );
};

export default connect(
  (state) => ({
    //accountID: state.global.accountID, this is already coming from the parent props
    accountName: state.entities.global.accountName,
    accounts: state.entities.global.accounts,
    auth: state.entities.auth,
    machines: state.entities.global.machines,
  }),
  {
    getMachines: globalActions.getMachines,
    setAccount: globalActions.setAccount,
    invalidateSites: siteActions.invalidateSites,
  }
)(DefaultSidebar);
